/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./remove-button.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/utility/migration/cross--editor-close';
import { fg } from '@atlaskit/platform-feature-flags';
import { Pressable } from '@atlaskit/primitives/compiled';
const removeButtonStyles = {
  root: "_19itglyw _2rkogqwt _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};

// To be removed with platform-component-visual-refresh (BLU-2992)
const removeButtonStylesOld = {
  root: "_19itglyw _2rko1l5z _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _ahbqze3t _12l2ze3t _1pfhze3t _6rthze3t _kqswstnw _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syaz1bah _80omtlke _lcxv1wug _1ah3ze3t _30l31eu2"
};
const removeButtonStylesOldIcon = {
  root: "_rjxpze3t"
};
const removeButtonStylesNewIcon = {
  root: "_rjxpv77o"
};
const RemoveButton = ({
  'aria-label': ariaLabel,
  onClick,
  onFocus,
  onBlur,
  onKeyPress,
  onMouseOver,
  onMouseOut,
  testId
}) => {
  return /*#__PURE__*/React.createElement(Pressable, {
    xcss: cx(
    // TODO: When cleaning up all these feature gates, they should just be converged into a single `styles` object.
    fg('platform-component-visual-refresh') && removeButtonStyles.root, !fg('platform-component-visual-refresh') && removeButtonStylesOld.root, removeButtonStylesOldIcon.root, fg('platform-visual-refresh-icons') && removeButtonStylesNewIcon.root),
    "aria-label": ariaLabel,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyPress: onKeyPress,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    testId: testId
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    color: "currentColor",
    label: "",
    LEGACY_size: "small"
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default RemoveButton;